import { Component } from '@angular/core';
import { SpinnerComponent } from 'src/app/common/spinner/spinner.component';

import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { Router } from '@angular/router';
import { PasswordToggleComponent } from 'src/app/common/password-toggle/password-toggle.component';

@Component({
  selector: 'app-auth',
  imports: [
    SpinnerComponent,
    ReactiveFormsModule,
    PasswordToggleComponent
],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss',
})
export class AuthComponent {
  //UI FLAGS
  showLogin: boolean = false;
  currentField: 'email' | 'password' = 'email';
  isLoading: boolean = false;
  showPassword: boolean = false;
  error_message: string = '';
  //DATA
  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private router: Router
  ) {
    this.initForm();
  }
  ngOnInit() {
    // added to trigger the spawn of login modal on re-route
    localStorage.setItem("trigger", "{}")
    this.router.navigate(['/'])

    // if(this.auth.isAuthenticated()){
    //   this.router.navigate(['/']);
    // }
  }
  initForm() {
    this.form = this.fb.group({
      email: [
        '',
        [Validators.required, Validators.maxLength(50), Validators.email],
      ],
      password: ['', [Validators.required]],
    });
  }
  apiLogin() {
    const email = this.form.controls['email'].value;
    const password = this.form.controls['password'].value;
    this.isLoading = true;
    this.auth.login(email, password, false).subscribe({
      error: (err) => this.onError('Incorrect Password'),
      complete: () => this.onLoginSuccess(),
    });
  }
  enableSignIn(enable: boolean){
    this.showLogin = enable;
  }
  isFormControlValid(controlName: string) {
    return this.form.controls[controlName].valid;
  }
  onSubmit() {
    if (!this.form.controls[this.currentField].valid) {
      return;
    }
    this.clearErrors();
    switch (this.currentField){
      case 'password':
        this.apiLogin();
        break;
    }
  }
  onRegister() {
    this.router.navigate(['/register']);
  }
  onLoginSuccess(){
    this.router.navigate([this.auth.getRoleIndex()]);
  }
  onError(message: string) {
    this.isLoading = false;
    this.error_message = message;
  }
  clearErrors() {
    this.error_message = '';
  }
  changeAccount() {
    this.form.controls['email'].setValue('');
    this.currentField = 'email';
    this.error_message = '';
  }
}
